<script setup lang="ts">
import {viewportSize} from '@teemill/common/helpers';
import {LiteProduct} from '@teemill/common/models';

withDefaults(
  defineProps<{
    products: LiteProduct[];
    titleText: string;
    titleAlignment?: 'left' | 'center';
  }>(),
  {
    titleAlignment: 'center',
  }
);

defineEmits<{
  (event: 'click', product: LiteProduct): void;
}>();

const getAltText = (product: LiteProduct) => {
  if (product.lifestyleImage) {
    return product.lifestyleImageAlt || '';
  }

  return product.imageAlt || '';
};
</script>

<template>
  <div v-if="products.length" class="section-product-list mb-8">
    <h4
      v-if="titleText"
      :class="{
        center: titleAlignment === 'center',
        'mb-8': true,
      }"
    >
      {{ titleText }}
    </h4>
    <tml-grid :breakpoints="{sm: 2, lg: 4}">
      <template
        v-for="product in products"
        :key="`${product.id}-${product.optionId || 0}`"
      >
        <tml-new-pod
          :title="product.name"
          :title-size="viewportSize.isSmaller('md') ? 0 : 1"
          :image="product.lifestyleImage || product.image"
          :alt-text="getAltText(product)"
          :href="`/product/${product.urlName}/`"
          :price="product.price"
          :sale-price="product.salePrice"
          lazy-load
          :image-src-set="[
            {width: 320, height: 320},
            {width: 480, height: 480},
            {width: 640, height: 640},
          ]"
          @click="$emit('click', product)"
        >
        </tml-new-pod>
      </template>
    </tml-grid>
  </div>
</template>
